import React, {SFC, useEffect, useState} from "react";
import Container from "@material-ui/core/Container";
import {
    Box,
    Breadcrumbs,
    Button,
    Card,
    Grid,
    GridItemsAlignment,
    makeStyles,
    Typography,
    useMediaQuery
} from "@material-ui/core";
import Navigation from "../../Components/Navigation";
import {ReactComponent as PetCatSVG} from "../../Images/petCat.svg";
import {ReactComponent as PetDogSVG} from "../../Images/petDogNew.svg";
import {ReactComponent as AddPetSVG} from "../../Images/addPetIcon.svg";
import {Link} from "react-router-dom";
import RemovePet from "../../Components/Modals/RemovePet";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/store";
import {useTheme} from "@material-ui/core/styles";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import {setPetAge, setPetType} from "../../utils/petInfo";

interface Props {
    isOnBoarding: boolean,
    setIsOnBoarding: React.Dispatch<React.SetStateAction<boolean>>,
}

const useStyle = makeStyles(() => ({
    button: {
        display: "flex",
        justifyContent: "space-between"
    },
    deleteButton: {
        padding: "13px 20px",
        border: "1.5px solid #FF6D6D",
        color: "#EA5858"
    },
    link: {
        textDecoration: "none"
    }
}));

const PetEdit: SFC<Props> = ({isOnBoarding, setIsOnBoarding}: Props) => {
    const [actualImageUrl, setActualImageUrl] = useState("");
    const [isRemoveModalVisible, setIsRemoveModalvisible] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const alignmentResponsive: GridItemsAlignment = isMobile ? "center" : "flex-start";
    const pet = useSelector((state: RootState) => state?.pets.selectedPet);
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const branding = useSelector((state: RootState) => state?.branding);
    const {id, name, type, imageUrl, breed, dateOfBirth} = pet;
    const classes = useStyle();

    useEffect(() => {
        if (imageUrl) setActualImageUrl(imageUrl);
    }, [imageUrl]);

    return (
        <Container maxWidth="md">
            <Box marginTop="115px" marginBottom="75px">
                <Grid container>
                    {!isMobile &&
                    <Grid item md={3} xs={12}>
                        <Navigation/>
                    </Grid>
                    }
                    <Grid item md={9} xs={12}>
                        <Card
                            variant="outlined"
                            style={{padding: 25}}
                        >
                            <Box marginBottom="55px">
                                <Breadcrumbs separator={<NavigateNextIcon fontSize="large"/>} aria-label="breadcrumb">
                                    <Link color="inherit" to="/pets" style={{textDecoration: "none"}}>
                                        <Typography variant="h2">All Pets</Typography>
                                    </Link>
                                    <Typography variant="h2" style={{wordBreak: "break-word"}}>{name}</Typography>
                                </Breadcrumbs>
                            </Box>
                            <Box>
                                <Grid container spacing={3}>
                                    <Grid container item xs={12} sm={3} alignItems={alignmentResponsive}
                                        justify="center">
                                        <Box
                                            marginBottom={isMobile ? "30px" : "0"}
                                        >
                                            {
                                                actualImageUrl ?
                                                    <img src={imageUrl}
                                                        style={{borderRadius: "4px", objectFit: "cover"}} width="100"
                                                        height="100" onError={() => {
                                                            setActualImageUrl("");
                                                        }}/>
                                                    :
                                                    // Using vanilla js object and select by the key, so we could switch i
                                                    !isWhiteLabel ?
                                                        ({
                                                            "FELINE": <PetCatSVG/>,
                                                            "CANINE": <PetDogSVG/>
                                                        }[setPetType(type)] ||
                                                            <Box display="flex" justifyContent="center" alignItems="center"
                                                                width="100px" height="100px">
                                                                <AddPetSVG/>
                                                            </Box>
                                                        )
                                                        :
                                                        <Box display="flex" justifyContent="center"
                                                            alignItems="center" width="100px"
                                                            height="100px">
                                                            <img
                                                                src={branding.logo}
                                                                width="100%"
                                                            />
                                                        </Box>
                                            }
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <Box
                                            marginRight="auto"
                                        >
                                            <Box
                                                marginBottom="10px"
                                            >
                                                <Typography
                                                    variant="h4"
                                                    style={{textTransform: "capitalize", whiteSpace: "break-spaces", wordBreak: "break-word", paddingRight: !isMobile ? "40px" : "0px"}}
                                                >
                                                    {name}
                                                </Typography>
                                            </Box>
                                            <Typography autoCapitalize="" color="textSecondary">
                                                {breed ? `${breed} - ` : null}
                                                {setPetAge(dateOfBirth)}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    <Link to={`${id}/general`} className={classes.link}>
                                        <Button
                                            variant="contained"
                                            fullWidth
                                            className={classes.button}
                                            endIcon={<NavigateNextIcon fontSize="large"/>}
                                        >
                                            General Information
                                        </Button>
                                    </Link>
                                </Grid>
                                {/*<Grid item xs={12} sm={6}>*/}
                                {/*	<Button*/}
                                {/*		variant="contained"*/}
                                {/*		fullWidth*/}
                                {/*		className={classes.button}*/}
                                {/*		endIcon={<NavigateNextIcon fontSize="large"/>}*/}
                                {/*	>*/}
                                {/*		Medication*/}
                                {/*	</Button>*/}
                                {/*</Grid>*/}
                                <Grid item xs={12} sm={6}>
                                    <Link to={`${id}/medicalConditions`} className={classes.link}>
                                        <Button
                                            variant="contained"
                                            fullWidth
                                            className={classes.button}
                                            endIcon={<NavigateNextIcon fontSize="large"/>}
                                        >
                                            Health Summary
                                        </Button>
                                    </Link>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Link to={`${id}/medicalRecords`} className={classes.link}>
                                        <Button
                                            variant="contained"
                                            fullWidth
                                            className={classes.button}
                                            endIcon={<NavigateNextIcon fontSize="large"/>}
                                        >
                                            Medical Records
                                        </Button>
                                    </Link>
                                </Grid>
                            </Grid>
                            <Box marginTop="30px">
                                <Button
                                    variant="contained"
                                    classes={{root: classes.deleteButton}}
                                    onClick={() => setIsRemoveModalvisible(true)}
                                >
                                    Remove Pet
                                </Button>
                            </Box>
                            <RemovePet
                                onClose={() => {
                                    setIsRemoveModalvisible(false);
                                }}
                                isOpen={isRemoveModalVisible}
                                petId={id}
                            />
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default PetEdit;
